var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImgPlaceholder = function SvgImgPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#292929",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 30.084a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 12H13c-4.96 0-9 4.04-9 9v38c0 4.96 4.04 9 9 9h54c4.96 0 9-4.04 9-9V21c0-4.96-4.04-9-9-9Zm-54 6h54c1.652 0 3 1.348 3 3v32.844l-7.637-7.637c-3.508-3.508-9.218-3.508-12.726 0l-4.926 4.926a1.011 1.011 0 0 1-1.418.004l-12.93-12.93c-3.398-3.398-9.328-3.398-12.726 0L10 45.844V21c0-1.652 1.348-3 3-3Zm0 44c-1.652 0-3-1.348-3-3v-4.672L21.879 42.45a2.999 2.999 0 0 1 4.242 0l12.934 12.934c2.726 2.719 7.168 2.722 9.894-.004l4.93-4.93a2.999 2.999 0 0 1 4.242 0l10.803 10.803C68.399 61.7 67.74 62 67 62H13Z"
  }))));
};
export default SvgImgPlaceholder;